module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/diners_club@2x-e428308fba5d20f62f0a55fc4a4fca73.png";